import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { CommonComponentsModule } from "src/app/common-components";
import { AnlageApiMonitoringStatusLedComponent } from "./status-led/status-led.component";

@NgModule({
  imports: [ReactiveFormsModule, CommonComponentsModule],
  declarations: [AnlageApiMonitoringStatusLedComponent],
  exports: [AnlageApiMonitoringStatusLedComponent],
})
export class AnlageApiMonitoringComponentsModule {}
